/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Apply file: Passport have to be provided first
 * @export
 * @interface PaxCheckTravelDocumentRequired
 */
export interface PaxCheckTravelDocumentRequired {
    /**
     * 
     * @type {string}
     * @memberof PaxCheckTravelDocumentRequired
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckTravelDocumentRequired interface.
 */
export function instanceOfPaxCheckTravelDocumentRequired(value: object): value is PaxCheckTravelDocumentRequired {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckTravelDocumentRequiredFromJSON(json: any): PaxCheckTravelDocumentRequired {
    return PaxCheckTravelDocumentRequiredFromJSONTyped(json, false);
}

export function PaxCheckTravelDocumentRequiredFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckTravelDocumentRequired {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
    };
}

export function PaxCheckTravelDocumentRequiredToJSON(json: any): PaxCheckTravelDocumentRequired {
    return PaxCheckTravelDocumentRequiredToJSONTyped(json, false);
}

export function PaxCheckTravelDocumentRequiredToJSONTyped(value?: PaxCheckTravelDocumentRequired | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
    };
}

